/**
 * Shared QueryClient singleton — consistent config across the app.
 * Import this instead of creating new QueryClient instances.
 */
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 1000 * 60 * 2, retry: 1 },
  },
});
